export default {
  "content": "<title>Man</title><path d=\"M208 208v264a23.73 23.73 0 0024 24 23.73 23.73 0 0024-24\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 336v136a23.73 23.73 0 0024 24 23.73 23.73 0 0024-24V208\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M208 192v88a23.72 23.72 0 01-24 24 23.72 23.72 0 01-24-24v-88a48 48 0 0148-48h96a48 48 0 0148 48v88a23.72 23.72 0 01-24 24 23.72 23.72 0 01-24-24v-88\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"256\" cy=\"56\" r=\"40\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};